module.exports = (__webpack_require__(9))(36);


//////////////////
// WEBPACK FOOTER
// delegated ./public/javascripts/jquery/ui/jquery.ui.widget.js from dll-reference jquery_ui_lib
// module id = 16
// module chunks = 0